module.exports = require("@pb/kit-util-key-codes");